/**
 * 住院医生路由
 */
var basePath = 'emr'
const emrRouters = [
  {
    path: `${basePath}/patient-list`,
    name: `${basePath}/patient-list`,
    meta: {
      title: '电子病历',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/emr/patient-list.vue'], resolve)
  },
  {
    path: `${basePath}/emr-reader/:inpatient_record_id/:patient_id`,
    name: `${basePath}/emr-reader`,
    meta: {
      title: '电子病历查阅',
      requiresAuth: true,
      nav: {
        title: '电子病历',
        path: '/default/emr/patient-list',
        children: null
      }
    },
    component: resolve => require(['../views/page/emr/emr-reader.vue'], resolve)
  }
]

export default emrRouters
